import { useAuth } from "components/custom/authprovider";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { SAlert } from "utils/functions";
import { SAText } from "utils/functions";
import { validatePhoneNumber } from "utils/functions";
import { validateEmail } from "utils/functions";
import { FormatPhone } from "utils/functions";
import { getDeviceFingerprint } from "utils/functions";
import { stateArray } from "utils/arrays";
import { GET_CUSTOMER_PROFILE } from "graphql/queries/users";
import { useMutation, useQuery } from "@apollo/client";
import { PRIVATE_SEND_EMAIL } from "graphql/mutations/users";
import { UPDATE_USER_PROFILE } from "graphql/mutations/users";
import { APPCOOKIE } from "utils/defaults";
import { EmailAlert } from "utils/defaults";
import { SubDirectory } from "utils/defaults";
import { SMSAlert } from "utils/defaults";
import { PUBLIC_SEND_EMAIL } from "graphql/mutations/users";
import { PUBLIC_SEND_SMS } from "graphql/mutations/users";
import { UPDATE_USER_EMAIL_PHONE } from "graphql/mutations/users";
import { validateWholeNumber } from "utils/functions";
import useAutoLogout from "utils/autoLogout";

const { CardHeader, CardBody, CardFooter, Card, Col, Row, FormGroup, Input, Button } = require("reactstrap");

function Profile(){
  useAutoLogout();

  const history = useHistory();
  const {wt, setWT, setIsAuthenticated}  = useAuth();
  const [setAppLoading] = useState(true);
  const [fielderrors, setFieldError] = useState([]);
  const [step, setStep] = useState(1);
  const [tempPhone, setTempPhone] = useState();
  const [tempEmail, setTempEmail] = useState();

  const [userdata, setUserData] = useState({
    firstname: "",
    lastname: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
    phone: wt.p,
    email: "",
  });

  const { loading, error, data, onError } = useQuery(GET_CUSTOMER_PROFILE,{
    notifyOnNetworkStatusChange: false,
    fetchPolicy: 'cache-and-network',
    context: {
      headers: {
        authorization: wt && wt.wt ? `Bearer ${wt.wt}` : '', // Include the token in the request header
        'X-Device-Fingerprint': getDeviceFingerprint(), // Include the device fingerprint in a custom header
      },
    },
    onError: (errors) => {
      if (errors.networkError) {
        const serverError = errors.networkError.result.errors[0].message;
        if(serverError === "Authentication required."){
          history.push({pathname:"/logout"});
        }
      } 
    }
  });

  const [privateSendEmail] = useMutation(PRIVATE_SEND_EMAIL, {
    context: {
      headers: {
        authorization: wt && wt.wt ? `Bearer ${wt.wt}` : '', // Include the token in the request header
        'X-Device-Fingerprint': getDeviceFingerprint(), // Include the device fingerprint in a custom header
      },
    },
    onError: (errors) => {
      if (errors.networkError) {
        const serverError = errors.networkError.result.errors[0].message;
        if(serverError === "Authentication required."){
          history.push({pathname:"/logout"});
        }
      } 
    }
  });

  const [publicSendEmail] = useMutation(PUBLIC_SEND_EMAIL, {
    context: {
      headers: {
        authorization: wt && wt.wt ? `Bearer ${wt.wt}` : '', // Include the token in the request header
        'X-Device-Fingerprint': getDeviceFingerprint(), // Include the device fingerprint in a custom header
      },
    },
    onError: (errors) => {
      if (errors.networkError) {
        const serverError = errors.networkError.result.errors[0].message;
        if(serverError === "Authentication required."){
          history.push({pathname:"/logout"});
        }
      } 
    }
  });

  const [publicSendSMS] = useMutation(PUBLIC_SEND_SMS, {
    context: {
      headers: {
        authorization: wt && wt.wt ? `Bearer ${wt.wt}` : '', // Include the token in the request header
        'X-Device-Fingerprint': getDeviceFingerprint(), // Include the device fingerprint in a custom header
      },
    },
    onError: (errors) => {
      if (errors.networkError) {
        const serverError = errors.networkError.result.errors[0].message;
        if(serverError === "Authentication required."){
          history.push({pathname:"/logout"});
        }
      } 
    }
  });

  const [updateEmailPhone] = useMutation(UPDATE_USER_EMAIL_PHONE, {
    context: {
      headers: {
        authorization: wt && wt.wt ? `Bearer ${wt.wt}` : '', // Include the token in the request header
        'X-Device-Fingerprint': getDeviceFingerprint(), // Include the device fingerprint in a custom header
      },
    },
    onError: (errors) => {
      if (errors.networkError) {
        const serverError = errors.networkError.result.errors[0].message;
        if(serverError === "Authentication required."){
          history.push({pathname:"/logout"});
        }
      } 
    }
  });
  const [updateProfile] = useMutation(UPDATE_USER_PROFILE, {
    context: {
      headers: {
        authorization: wt && wt.wt ? `Bearer ${wt.wt}` : '', // Include the token in the request header
        'X-Device-Fingerprint': getDeviceFingerprint(), // Include the device fingerprint in a custom header
      },
    },
    onError: (errors) => {
      if (errors.networkError) {
        const serverError = errors.networkError.result.errors[0].message;
        if(serverError === "Authentication required."){
          history.push({pathname:"/logout"});
        }
      } 
    }
  });

  const UpdateUserData = (e, type = '') => {
    if(type !== "array"){
      let value = e.target.value;
      if(e.target.type === 'number'){
        if(value === '') value = 0;
        else value = parseInt(value);
      }
  
      if(type === 'boolean') {
        if(typeof(value) === "string"){
          const a = (value === 'true');
          value = a;
        }
      }
  
      setUserData(prevState => {
        return { ...prevState, [e.target.name]: value};
      });
    }
    else{
      setUserData(prevState => {
        return { ...prevState, [e.name]:e.value};
      });
    }
  };

  const CheckError = (e) =>{
    if(fielderrors.length > 0){
      const q = fielderrors.find((a)=>a.field === e);
      if(q) return q.error; else return false;
    }
    else return false;
  };

  const UpdateProfile = () => {
    let valid = true;
    setFieldError(() => []);

    if(userdata.firstname.trim() === "" || userdata.firstname === undefined) {
      valid = false;
      setFieldError(prevState => { return [ ...prevState, {field: "firstname", error: "First Name is required"}]; });
    }

    if(userdata.lastname.trim() === "" || userdata.lastname === undefined) {
      valid = false;
      setFieldError(prevState => { return [ ...prevState, {field: "lastname", error: "Last Name is required"}]; });
    }

    if(userdata.email.trim() === "" || userdata.email === undefined) {
      valid = false;
      setFieldError(prevState => { return [ ...prevState, {field: "email", error: "Email is required"}]; });
    }

    if(userdata.address1.trim() === "" || userdata.address1 === undefined) {
      valid = false;
      setFieldError(prevState => { return [ ...prevState, {field: "address1", error: "Address is required"}]; });
    }

    if(userdata.city.trim() === "" || userdata.city === undefined) {
      valid = false;
      setFieldError(prevState => { return [ ...prevState, {field: "city", error: "City is required"}]; });
    }

    if(userdata.state.trim() === "" || userdata.state === undefined) {
      valid = false;
      setFieldError(prevState => { return [ ...prevState, {field: "state", error: "State is required"}]; });
    }

    if(userdata.zip === "" || userdata.zip === undefined) {
      valid = false;
      setFieldError(prevState => { return [ ...prevState, {field: "zip", error: "Zip is required"}]; });
    }

    if(valid){
      setAppLoading(true);
      privateSendEmail()
      .then((res) => {
        if(res.data.privateSendEmail.status){
          SAlert(EmailAlert.title, "text", EmailAlert.label, EmailAlert.icon, (v) => {
            FinalizeProfileUpdate(v);
          });
        }
        else{
          SAText("Error", res.data.privateSendEmail.error, "error");
        }
      })
      .catch((err) => {
        SAText("Error", err, "error");
      })
      .finally(() =>{
        setAppLoading(false);
      });
    }
  };

  const UpdatePhoneEmail = (type) => {
    let valid = true;
    setFieldError(() => []);

    if(type === "email"){
      if(tempEmail !== userdata.email && tempEmail !== undefined){
        if(tempEmail.trim() === "" || tempEmail === undefined) {
          valid = false;
          setFieldError(prevState => { return [ ...prevState, {field: "email", error: "Email is required"}]; });
        }
    
        if(!validateEmail(tempEmail)) {
          valid = false;
          setFieldError(prevState => { return [ ...prevState, {field: "email", error: "Invalid Email Format"}]; });
        }

        if(valid){
          setAppLoading(true);

          publicSendEmail({ variables: {email: tempEmail}})
          .then((res) => {
            if(res.data.publicSendEmail.status){
              SAlert(EmailAlert.title, "text", EmailAlert.label, EmailAlert.icon, (v) => {
                FinalizePhoneEmailUpdate(v, type);
              });
            }
            else{
              SAText("Error", res.data.publicSendEmail.error, "error");
            }
          })
          .catch((err) => {
            SAText("Error", err, "error");
          })
          .finally(() =>{
            setAppLoading(false);
          });
        }
      }
    }
    else if(type === "phone"){
      if(tempPhone !== userdata.phone && tempPhone !== undefined){
        if(!validatePhoneNumber(tempPhone)) {
          valid = false;
          setFieldError(prevState => { return [ ...prevState, {field: "phone", error: "Invalid Phone Format"}]; });
        }

        if(valid){
          setAppLoading(true);

          publicSendSMS({ variables: {type: "profileupdate", phone: tempPhone}})
          .then((smsres) => {
            if(smsres.data.publicSendSMS.status){
              SAlert(SMSAlert.title, "text", SMSAlert.label, SMSAlert.icon, (v) => {
                FinalizePhoneEmailUpdate(v, type);
              });
            }
            else{
              SAText("Error", smsres.data.publicSendSMS.error, "error");
            }
          })
          .catch((err) => {
            SAText("Error", err, "error");
          })
          .finally(() =>{
            setAppLoading(false);
          });
        }
      }
    }
  };

  const FinalizePhoneEmailUpdate = (code, type) => {
    // console.log("Code", code)
    // console.log("Type", type)
    // console.log("UserData", userdata)
    if(code && type){
      updateEmailPhone({ variables: {type: type, theValue: (type === "phone" ? tempPhone : tempEmail), code: code}})
      .then((res) => {
        if(res.data.updateEmailPhone.status){
           //SET COOKIE AND AUTH
          const TheCookie ={
            wt: res.data.updateEmailPhone.token,
            dt: res.data.updateEmailPhone.dt,
            p: wt.p
          };
          const token = localStorage.setItem( APPCOOKIE, JSON.stringify(TheCookie) );

          setWT({ 
            wt: res.data.updateEmailPhone.token, 
            dt: res.data.updateEmailPhone.dt,
            p: wt.p
          });

          setIsAuthenticated({ token });

          SAText("Success", "Profile Updated Successfully", "success", () => {
            history.push("/" + SubDirectory + "verifyaccount");
          });
        }
        else{
          SAText("Error", res.data.updateEmailPhone.error, "error");
        }
      })
      .catch((err) => {
        SAText("Error", err, "error");
      })
      .finally(() =>{
        setAppLoading(false);
      });
    }
  };

  const FinalizeProfileUpdate = (code) => {
    setAppLoading(true);
    updateProfile({ variables: {data: userdata, code: code}})
    .then((res) => {
      if(res.data.updateProfile.status){
          //SET COOKIE AND AUTH
          const TheCookie ={
            wt: res.data.updateProfile.token,
            dt: res.data.updateProfile.dt,
            p: wt.p
          };
          const token = localStorage.setItem( APPCOOKIE, JSON.stringify(TheCookie) );

          setWT({ 
            wt: res.data.updateProfile.token, 
            dt: res.data.updateProfile.dt,
            p: wt.p
          });

          setIsAuthenticated({ token });

          SAText("Success", "Profile Updated Successfully", "success", () => {
            history.push("/" + SubDirectory + "verifyaccount");
          });
      }
      else{
        SAText("Error", res.data.updateProfile.error, "error");
      }
    })
    .catch((err) => {
      SAText("Error", err, "error");
    })
    .finally(() =>{
      setAppLoading(false);
    });
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (validateWholeNumber(value)) {
      setUserData(prevState => {
        return { ...prevState, zip:value};
      });
    }
  };

  useEffect(() => {
    const onCompleted = (data) => { 
      if(data){
        setUserData(() => data.getProfileInformation.customer);
      } 

      // setTimeout(() => setAppLoading(false), 1000)
    };
    if (onCompleted || onError) {
      if (onCompleted && !loading && !error) {
        onCompleted(data);
      } else if (onError && !loading && error) {
        onError(error);
      }
    }
  }, [loading, data, error, onError]);

  return (
    <div className="content">
    <Row>
        <Col md="12">
          <Card>
            <CardHeader className='subTitle'>Update Profile Information</CardHeader>
            <CardBody>
              {step=== 1 && userdata &&
              <>
                <Row>
                  <Col md="12">
                    <p>In order to complete the profile update, you will be sent an email confirmation code that will be required in order to proceed. </p>
                  </Col>
                </Row>

                <Row>
                  <Col md="6">
                    <FormGroup>
                      <label className="subTitle">* First Name:</label>
                      <Input
                        placeholder="First Name"
                        type="text"
                        name="firstname"
                        value={userdata.firstname}
                        onChange={ e => UpdateUserData(e) }
                        autoComplete = "off"
                        maxLength={30}
                        className={CheckError("firstname") ? 'error' : ''}
                      />
                      <span className='errorMessage'>{CheckError("firstname") ? CheckError("firstname") : ''}</span>
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="subTitle">* Last Name:</label>
                      <Input
                        placeholder="Last Name"
                        type="text"
                        name="lastname"
                        value={userdata.lastname}
                        onChange={ e => UpdateUserData(e) }
                        autoComplete = "off"
                        maxLength={30}
                        className={CheckError("lastname") ? 'error' : ''}
                      />
                      <span className='errorMessage'>{CheckError("lastname") ? CheckError("lastname") : ''}</span>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md="6">
                    <FormGroup>
                    {/* <span className='specialButton' onClick={() => setStep(2)}>Click Here Update Phone</span> */}
                      <label className="subTitle" style={{width:"100%"}}>* Phone: </label>
                      <Input
                        placeholder="Phone"
                        type="text"
                        name="phone"
                        value={userdata.phone}
                        readOnly = {true}
                        onChange={ e => FormatPhone(e, setUserData) }
                        autoComplete = "off"
                        maxLength={60}
                        className={CheckError("phone") ? 'error' : ''}
                      />
                      <span className='errorMessage'>{CheckError("phone") ? CheckError("phone") : ''}</span>
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                    {/* <span className='specialButton' onClick={() => setStep(3)}>Click Here Update Email</span> */}
                      <label className="subTitle"  style={{width:"100%"}}>* Email: </label>
                      <Input
                        placeholder="Email"
                        type="text"
                        name="email"
                        value={userdata.email}
                        readOnly = {true}
                        onChange={ e => UpdateUserData(e) }
                        autoComplete = "off"
                        maxLength={60}
                        className={CheckError("email") ? 'error' : ''}
                      />
                      <span className='errorMessage'>{CheckError("email") ? CheckError("email") : ''}</span>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md="6">
                    <FormGroup>
                      <label className="subTitle">* Address:</label>
                      <Input
                        placeholder="Address"
                        type="text"
                        name="address1"
                        value={userdata.address1}
                        onChange={ e => UpdateUserData(e) }
                        autoComplete = "off"
                        maxLength={60}
                        className={CheckError("address1") ? 'error' : ''}
                      />
                      <span className='errorMessage'>{CheckError("address1") ? CheckError("address1") : ''}</span>
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="subTitle">Address 2:</label>
                      <Input
                        placeholder="Address2"
                        type="text"
                        name="address2"
                        value={userdata.address2}
                        onChange={ e => UpdateUserData(e) }
                        autoComplete = "off"
                        maxLength={30}
                        className={CheckError("address2") ? 'error' : ''}
                      />
                      <span className='errorMessage'>{CheckError("address2") ? CheckError("address2") : ''}</span>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md="6">
                    <FormGroup>
                      <label className="subTitle">* City:</label>
                      <Input
                        placeholder="City"
                        type="text"
                        name="city"
                        value={userdata.city}
                        onChange={ e => UpdateUserData(e) }
                        autoComplete = "off"
                        maxLength={20}
                        className={CheckError("city") ? 'error' : ''}
                      />
                      <span className='errorMessage'>{CheckError("city") ? CheckError("city") : ''}</span>
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="subTitle">* State:</label>
                      <select className={(CheckError("state") ? 'error' : '') + ' form-control'}
                        name="state"
                        value={userdata.state}
                        onChange={ e => UpdateUserData(e) }
                        maxLength={2}
                      >
                        <option value="">Select State</option>
                        {stateArray.map((value, key) => {
                          return (
                            <option value={value.abbreviation} key={key}>
                              {value.name}
                            </option>
                          );
                        })}
                      </select>
                      <span className='errorMessage'>{CheckError("state") ? CheckError("state") : ''}</span>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md="6">
                    <FormGroup>
                      <label className="subTitle">* Zip:</label>
                      <Input
                        placeholder="Zip"
                        type="text"
                        name="zip"
                        value={userdata.zip}
                        onChange={ handleInputChange }
                        autoComplete = "off"
                        maxLength={7}
                        className={CheckError("zip") ? 'error' : ''}
                      />
                      <span className='errorMessage'>{CheckError("zip") ? CheckError("zip") : ''}</span>
                    </FormGroup>
                  </Col>
                </Row>
              </>
              }

              {step === 2 &&
                <Row>
                  <Col md = "12">
                  <FormGroup>
                      <label className="subTitle">* Phone: </label>
                      <Input
                        placeholder="Phone"
                        type="text"
                        name="phone"
                        value={tempPhone ? tempPhone : userdata.phone}
                        onChange={ e => FormatPhone(e, setTempPhone, true) }
                        autoComplete = "off"
                        maxLength={60}
                        className={CheckError("phone") ? 'error' : ''}
                      />
                      <span className='errorMessage'>{CheckError("phone") ? CheckError("phone") : ''}</span>
                    </FormGroup>
                  </Col>
                </Row>
              }

              {step === 3 &&
                <Row>
                  <Col md = "12">
                    <FormGroup>
                      <label className="subTitle">* Email: </label>
                      <Input
                        placeholder="Email"
                        type="text"
                        name="email"
                        value={tempEmail ? tempEmail : userdata.email}
                        onChange={ e => setTempEmail(e.target.value) }
                        autoComplete = "off"
                        maxLength={60}
                        className={CheckError("email") ? 'error' : ''}
                      />
                      <span className='errorMessage'>{CheckError("email") ? CheckError("email") : ''}</span>
                    </FormGroup>
                  </Col>
                </Row>
              }
            </CardBody>

            <CardFooter style={{textAlign:"center"}}>
              {step === 1 &&
              <>
                <Button 
                  className="btn-fill mwbtn" 
                  color="info" 
                  type="button" 
                  style={{width:"80%"}}
                  onClick = {() => UpdateProfile()}
                  >
                    Update Profile Information
                </Button>

                <p className="resetLink" style={{textAlign:"center", padding:"10px"}}>
                  <span 
                    style={{color:"red"}}
                    onClick = { () => {
                      history.push({pathname:"/verifyaccount"});
                    }}
                  >Cancel Profile Update
                  </span>
                </p>
              </>
              }

              {step === 2 &&
              <>
                <Button 
                  className="btn-fill mwbtn" 
                  color="info" 
                  type="button" 
                  style={{width:"80%"}}
                  onClick = {() => UpdatePhoneEmail("phone")}
                  >
                    Update Phone
                </Button>

                <p className="resetLink" style={{textAlign:"center", padding:"10px"}}>
                  <span 
                    style={{color:"red"}}
                    onClick = { () => setStep(1)}
                  >Back to Profile Information
                  </span>
                </p>

              </>
              }

              {step === 3 &&
              <>
                <Button 
                  className="btn-fill mwbtn" 
                  color="info" 
                  type="button" 
                  style={{width:"80%"}}
                  onClick = {() => UpdatePhoneEmail("email")}
                  >
                    Update Email
                </Button>

                <p className="resetLink" style={{textAlign:"center", padding:"10px"}}>
                  <span 
                    style={{color:"red"}}
                    onClick = { () => setStep(1)}
                  >Back to Profile Information
                  </span>
                </p>
              </>
              }

            </CardFooter>
                
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Profile;
